// extracted by mini-css-extract-plugin
module.exports = {"message":"Moder_message__2aBdG","actions":"Moder_actions__31M3Q"};